/**
 * i18n Configuration
 * Coláiste Lurgan Management System - Internationalization setup
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en';
import ga from './locales/ga';
import { canUseStorage } from '../hooks/useCookieConsent';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ga: { translation: ga },
    },
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: canUseStorage() ? ['localStorage'] : [],
      lookupLocalStorage: 'i18nextLng',
    },
  });

export default i18n;
